import { useAppContextStore } from '@src/contexts/AppContextStore';
import { ServerWindow } from '@src/lib/ServerWindow';
import { getWidthFromUserAgent } from '@src/lib/getWidthFromUserAgent';
import { useMemo } from 'react';
type WithAnalytics<T> = T & {
  analytics?: any;
  lintrk?: any;
  mixpanel?: any;
  trackerHistory?: Array<{
    label: string;
    properties?: any;
    options?: any;
  }>;
  _fbq?: any;
};
type WindowProxyType = WithAnalytics<Window & ServerWindow>;

// @ts-ignore
export const windowProxy: WindowProxyType = typeof window !== 'undefined' ? window : new ServerWindow();
export const useWindow = (options: {
  userAgent?: string;
  initialWidth?: number;
} = null): WindowProxyType => {
  const {
    contextStore
  } = useAppContextStore();
  const windowInstance = useMemo(() => {
    // console.log('useWindow')
    if (typeof window !== 'undefined') {
      return window;
    } else {
      const serverWindow = new ServerWindow();
      let width: number | null = options?.initialWidth ?? null;
      if (width == null && options?.userAgent) {
        width = getWidthFromUserAgent(options.userAgent);
      }
      if (width == null) {
        width = contextStore?.get('ssrWidthFromUserAgent') ?? null;
      }
      if (width == null) {
        width = getWidthFromUserAgent(options?.userAgent);
      }
      if (width != null && contextStore) {
        contextStore.set('ssrWidthFromUserAgent', width);
      }
      serverWindow.innerWidth = width;
      serverWindow.outerWidth = width;
      serverWindow.ssrInnerWidth = width;
      serverWindow.ssrOuterWidth = width;
      serverWindow.isServer = true;
      return serverWindow;
    }
  }, [options?.userAgent, options?.initialWidth, typeof window]);
  return windowInstance as WindowProxyType;
};